






















































































import {Component, Vue} from 'vue-property-decorator';

@Component({
    components: {},
    data() {
        return {
            redirectUrl: 'https://first-reader.jp/#link_contact',
            hasIframe: false,
        }
    },
    mounted(){
        this.detectIframe();
    },
    methods: {
        onRedirectTo() {
            window.open(
                // @ts-ignore
                this.redirectUrl,
                '_blank'
            );
        },
        detectIframe(){
            // @ts-ignore
            this.hasIframe = window.location !== window.parent.location;
        }
    }
})
export default class Footer extends Vue {

}
